import React from "react"
import "../../styles/generic/Header.css"


export const Header = ({title, actions, childHeight = 0, children = []}) => {

    return <div className={"eas-header-container"}>
        <div className={"eas-header"}>
            <div className={"title ant-page-header-heading-title"}>{title}</div>
            <div className={"spacer"}/>
            <div className={"actions"}>
                {actions}
            </div>
        </div>
        <div hidden={children.length === 0} className={"child-components"} style={{height: childHeight}}>
            {children}
        </div>
    </div>
}
